import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IData } from '../interface/authocode';
// import { Observable, throwError } from 'rxjs';
import { Observable, throwError, of } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map'
import { DatePipe } from '@angular/common';
import { User } from '../interface/user';
import { PAYMENT_URL, SERVER_URL } from '../../environments/environment';
import { Storage } from '@ionic/storage';
import {
  IonicToastService
} from '../api/ionic-toast.service';

@Injectable({
  providedIn: 'root'
})
export class HvserviceService {
  logFileStatus$: Observable<any>;
  private dataUrl: string = "assets/data.json";
  currentUser: any = 0;
  deviceplatform: any
  rootURL = SERVER_URL;
  data = [];
  isNetworkConnected: boolean = false;
  private Users: User[] = [];
  constructor(
    private httpClient: HttpClient,
    public http: Http,
    private storage: Storage,
    private datepipe: DatePipe,
    private ionicToastService: IonicToastService
  ) {

    if (localStorage.getItem('currentUser') != null &&
      localStorage.getItem('currentUser') != "[]") {
      if (localStorage.getItem('currentUser').length > 0) {
        if (JSON.parse(localStorage.getItem('currentUser'))) {
          var user = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser = user[0].UserId;
        }
      }
    }
  }

  getAuthCodes$(): Observable<any> {
    return this.httpClient.get<IData[]>(this.dataUrl)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  async getAttributes1$(attributeId) {
    try {
      let response = await fetch(this.rootURL + 'attribute?at=' + attributeId);
      this.handleErrors(response);
      let json = await response.json();
      // console.log("json: " + JSON.stringify(json));
    } catch (err) {
      // console.log("error: " + err);
    }
  }

  handleErrors(response) {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
  }

  handleError(error: HttpErrorResponse) {
    var message;
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      // console.log("error: ", error);
      message.error('An error occurred:', error.error.message);

    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      message = (
        `Backend returned code ${error.status}, ` + `body was: ${(error.error)}`);
    }

    return throwError(
      'Something bad happened; please try again later.' + message);
  };


  getVersionEntity$(): Observable<any> {
    // if (this.isNetworkConnected) {
    return this.httpClient.get(this.rootURL + 'appversion')
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
    // } else {
    //   return of(false);
    // }
  }

  getParentDetail$(emailId): Observable<any> {
    return this.httpClient.get(this.rootURL + 'parent?email=' + emailId)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  updateMyProfile$(body): Observable<any> {
    return this.httpClient
      .post(this.rootURL + 'user', body, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });

  }


  getUserEntity$(email: String): Observable<any> {
    return this.httpClient.get(this.rootURL + 'user?em=' + email)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  saveParent(data) {
    // console.log("saveParent: " + JSON.stringify(data));
    return this.httpClient.post(this.rootURL + 'parent', data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  verifyHCMembership(data) {
    return this.httpClient.post(this.rootURL + 'hcmember', data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  addHCMember(data) {
    return this.httpClient.put(this.rootURL + 'hcmember', data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  deleteStudent(studentId) {
    var data = {};
    return this.httpClient.post(this.rootURL + 'student?id=' + studentId, data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  savePayment(data) {
    // console.log("savePayment: " + JSON.stringify(data));
    return this.httpClient.post(this.rootURL + 'payment', data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  saveAttendanceEntity$(data): Observable<any> {
    // console.log("saveAttendanceEntity: " + JSON.stringify(data));
    return this.httpClient.post(this.rootURL + 'attendance', data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  saveTeacherAssigWork$(saveTeacherAssigment) {
    // console.log("123: " + JSON.stringify(saveTeacherAssigment));
    return this.httpClient
      .put(this.rootURL + 'teachercomm', saveTeacherAssigment, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });

  }

  getMyClassList$(teacherClass) {
    return this.httpClient.get(this.rootURL + 'studentcontact?c=' + teacherClass)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getCalenderDates$(currentYear): Observable<any> {
    return this.httpClient.get(
      this.rootURL + 'calendar?y=' + currentYear
    )
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getteacherAssigWork$(teacherId) {
    return this.httpClient.get(this.rootURL + 'teachercomm?t=' + teacherId)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  sendEmailforAdminToContact(data) {
    // console.log("data: " + JSON.stringify(data));
    return this.httpClient
      .post(this.rootURL + 'admin', data, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }


  authorizePayment(data): Observable<any> {
    return this.httpClient.post(
      PAYMENT_URL,
      data
    ).pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  createUser(users: User) {
    return this.httpClient
      .put(this.rootURL + 'user', users, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }

  captureLogDetails(Id, Messgae, Source, LogDate, UserId, Device, OS) {
    let body = {
      Id: Id,
      Messgae: Messgae,
      Source: Source,
      LogDate: LogDate,
      UserId: UserId,
      Device: "7",
      OS: "Android"
    };
    // console.log("body: " + JSON.stringify(body));
    return this.httpClient
      .post(this.rootURL + 'apilog', body, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }

  submitToChangeNewPass(UserID, Password) {
    let body = {
      UserID: UserID,
      Password: Password,
    };

    return this.httpClient
      .post(this.rootURL + 'auth', body,
        { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }

  sendEmailToResetPass(emailToResetPass) {
    var body = {};
    return this.httpClient
      .post(this.rootURL + 'auth?em=' + emailToResetPass, body,
        { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }


  paypalPayment(data) {
    // fetch access token details
    // let basicAuth = btoa('AS1gBqiubDY6bFBP3RreuEOvxovbXUaN06clabYL9G3h6E-S_tJ7mhT3xP8AiTBKnW761mHHRXDr8SJy:ECqO-5nD5Yn-HkDbMv9pcrtGfgW0MPADUVAKJfblS1i9WuPXoJTVosePRzsTb7ggz1XK-pFYyyuYanrt');
    // var authHeaders = new HttpHeaders({
    //   'Content-Type': 'application/x-www-form-urlencoded',
    //   'Authorization': 'Basic ' + basicAuth
    // });

    // var authData = {
    //   'grant_type': 'client_credentials'
    // };

    // let auth = this.httpClient.post(
    //   'https://api.sandbox.paypal.com/v1/oauth2/token',
    //   authData,
    //   { headers: authHeaders }
    // );

    //subscribe auth Observable and call payment API
    // let response = auth.subscribe(authResponse => {
    // console.log("authResponse: ", authResponse);
    // var headers = new HttpHeaders({
    //   'Accept': 'application/json',
    //   'Authorization': 'Bearer A21AAGD-espnguSR6ClcpriJZ1NmONaHl6T3oivjfshQt2NDtKaAzObn-T_15kS67p7An43k-zgS79j4ZxcpMaIcjlt16Hsdg'
    // });
    // let resp = this.httpClient.post(
    //   "https://api.sandbox.paypal.com/v2/checkout/orders/",
    //   data,
    //   { headers: headers }
    // );
    // resp.subscribe(respData => {
    //   console.log("respData: ", respData);

    //   //approve payment
    //   var approve
    //   //capture payment
    //   var captureHeaders = new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': 'Bearer A21AAGD-espnguSR6ClcpriJZ1NmONaHl6T3oivjfshQt2NDtKaAzObn-T_15kS67p7An43k-zgS79j4ZxcpMaIcjlt16Hsdg'
    //   });

    //   console.log("respData['id']: ", respData["id"]);
    //   let captureOrder = this.httpClient.post(
    //     'https://api.sandbox.paypal.com/v2/checkout/orders/' + respData["id"] + '/capture',
    //     data,
    //     { headers: captureHeaders }
    //   );
    //   captureOrder.subscribe(captureData => {
    //     console.log("captureData: ", captureData);
    //     return captureData;
    //   });
    //   //capture payment

    //   //approve payment
    // });
    // });
  }


  getUserDetailByEmailId(emailId: string): Observable<any> {
    // if (this.isNetworkConnected) {
    return this.httpClient
      .get<User>(this.rootURL + 'user?em=' + emailId)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
    // } else {
    //   return of(false);
    // }
  }

  getConnection() {
    this.storage.get('isConnected').then((val) => {
      return val;
    });
    // return null;
  }

  getAttributes$(attributeId): Observable<any> {
    return this.httpClient.get(
      this.rootURL + 'attribute?at=' + attributeId
    )
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getDocumentText(parentData) {
    return this.httpClient.post(this.rootURL + 'document',
      parentData)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getTeacherDetails$(userId) {
    var data = {};
    return this.httpClient.post(this.rootURL + 'teacher?uid=' + userId, data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getStudentList$(assigClass) {
    return this.httpClient.get(this.rootURL + 'student?c=' + assigClass)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getStudentForAttendanceEntity$(paramsToGetAttendance): Observable<any> {
    // console.log("getStudentForAttendanceEntity: " + JSON.stringify(paramsToGetAttendance));
    // console.log("test: " + this.rootURL + 'attendance?' + "class=" + paramsToGetAttendance.Class + "&teacherid=" + paramsToGetAttendance.TeacherId + "&weekno=" + paramsToGetAttendance.WeekNo);
    return this.httpClient.get(this.rootURL + 'attendance?' + "class=" + paramsToGetAttendance.Class + "&teacherid=" + paramsToGetAttendance.TeacherId + "&weekno=" + paramsToGetAttendance.WeekNo)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getTeacherDetailsEntity$(userId) {
    var data = {};
    return this.httpClient.post(this.rootURL + 'teacher?uid=' + userId, data)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getStudentListEntity$(assigClass): Observable<any> {
    return this.httpClient.get(this.rootURL + 'student?c=' + assigClass)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getCommunicationDetails$(itemId): Observable<any> {
    // console.log("palyload: " + itemId);
    return this.httpClient.get(this.rootURL + 'communication?id=' + itemId)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getCommunicationList$(body: any) {
    // console.log("palyload: " +  JSON.stringify(body));
    return this.httpClient.post(this.rootURL + 'communication', body)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getParentsList$(userClass): Observable<any> {
    return this.httpClient.post(this.rootURL + 'parent?c=' + userClass, "")
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  } 
  
  getAuthorizeKeys$(): Observable<any> {
    return this.httpClient.get(this.rootURL + 'auth?orgid=1&compcode=HV')
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  sendMessage$(saveTeacherAssigment) {
    // console.log("save Message: " + JSON.stringify(saveTeacherAssigment));
    return this.httpClient
      .put(this.rootURL + 'communication', saveTeacherAssigment, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });

  }

  getCaptureLogDetailsEntity$(Id, Messgae, Source, LogDate, UserId, Device, OS) {
    let body = {
      Id: Id,
      Messgae: Messgae,
      Source: Source,
      LogDate: LogDate,
      UserId: UserId,
      Device: "7",
      OS: this.deviceplatform
    };
    // console.log("body: " + JSON.stringify(body));
    return this.httpClient
      .post(this.rootURL + 'apilog', body, { observe: 'response' })
      .map((res) => {
        if (res) {
          if (res.status === 201) {
            return [{ status: res.status, json: res }]
          }
          else if (res.status === 200) {
            return [{ status: res.status, json: res }]
          }
        }
      }).catch((error: any) => {
        if (error.status === 500) {
          return throwError(error.status);
        }
        else if (error.status === 400) {
          return throwError(error.status);
        }
        else if (error.status === 409) {
          return throwError(error.status);
        }
        else if (error.status === 406) {
          return throwError(error.status);
        }
      });
  }


  // addUserRegistrationDetails
  addUserRegistrationDetails$(
    UserID,
    FirstName,
    LastName,
    Email,
    UserName,
    Password,
    Phone,
    Type,
    Active,
    Notes,
    AddedOn,
    AddedBy,
    ModifiedOn,
    ModifiedBy
  ) {
    // var todaysDate = new Date();
    // var todaysDate: String = this.datepipe.transform(new Date().toISOString(), 'MM/dd/yyyy');
    var todaysDate = "";


    return new Promise(resolve => {
      let header = new Headers();
      header.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: header });
      let body = '';
      body = this.bodyForRequest(UserID, FirstName, LastName, Email, UserName, Password, Phone, Type, Active, Notes, todaysDate, 0, todaysDate, 0);
      // console.log('serviceURL: ' + this.rootURL + "user" + '  body: ' + body + '  options: ' + options);
      this.http.put(this.rootURL + "user", body, options)
        .map(res => res.json()).subscribe(data => {
          this.data = data;
          resolve(this.data);
        }, err => {
          // console.log("error: " + err);
          this.data = err;
          resolve(this.data);
        });
    });

  }

  bodyForRequest(UserID, FirstName, LastName, Email, UserName, Password, Phone, Type, Active, Notes, AddedOn, AddedBy, ModifiedOn, ModifiedBy) {
    return JSON.stringify({
      UserID: UserID,
      FirstName: FirstName,
      LastName: LastName,
      Email: Email,
      UserName: UserName,
      Password: Password,
      Phone: Phone,
      Type: Type,
      Active: Active,
      Notes: Notes,
      AddedOn: AddedOn,
      AddedBy: AddedBy,
      ModifiedOn: ModifiedOn,
      ModifiedBy: ModifiedBy
    });
  }

  httpApiHeader() {
    return {
      headers: {
        "accept": "application/json",
        "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type"
      }
    };
  }
}
